import {
  EVENTS,
  Joyride,
  type EventData,
  type Origin,
  type Step,
} from "react-joyride";
import {
  handleButtonClickEventBuilder,
  sendEvent,
} from "../../utils/event-helpers";
import { useAppDispatch, useAppSelector } from "../../app/store";

const JoyRide = ({
  runTour,
  setRunTour,
}: {
  runTour: boolean;
  setRunTour: (run: boolean) => void;
}) => {
  const { userId, sessionId } = useAppSelector((state) => state.session);
  const dispatch = useAppDispatch();

  function handleJoyRideButtonPress(buttonAction: Origin) {
    if (!userId || !sessionId) return;

    const eventData = handleButtonClickEventBuilder(
      userId,
      sessionId,
      `JoyRide ${buttonAction}`,
      {},
    );
    void dispatch(sendEvent(eventData));
  }

  const handleJoyrideEvent = (data: EventData) => {
    const { type, origin } = data;

    if (type === EVENTS.TOUR_START) {
      localStorage.setItem("hasVisitedRecommender", "true");
      setRunTour(true);
    }

    if (type === EVENTS.TOUR_END) setRunTour(false);
    if (origin) handleJoyRideButtonPress(origin);
  };

  const steps: Step[] = [
    {
      target: '[data-tour="sidebar-container"]',
      content: (
        <>
          <b>Welcome to the recommendations page!</b>
          <br />
          Here, you can browse resources that will help you continue planning
          your career.
        </>
      ),
    },
    {
      target: '[data-tour="sidebar-toggle"]',
      content: (
        <>
          Here, you can find the <b>navigation menu</b>.
          <br /> Click here to expand or collapse it.
        </>
      ),
    },
    {
      target: '[data-tour="notification-dot"]',
      content: (
        <>
          <b>Recommended pages</b> will have this little notification icon.
        </>
      ),
    },
    {
      target: '[data-tour="best-match"]',
      content: (
        <>
          Our <b>top recommendation</b> will show this bubble.
        </>
      ),
    },
    {
      target: '[data-tour="bookmark-icon"]',
      content: (
        <>
          This is the <b>bookmark</b> icon.
          <br /> You can click on it to bookmark a resource.
        </>
      ),
    },
    {
      target: '[data-tour="sidebar-link-Bookmarks"]',
      content: (
        <>
          Click here to view your <b>bookmarked</b> resources.
        </>
      ),
    },
    {
      target: '[data-tour="sidebar-tabs"]',
      content:
        "You can click on these tabs to browse different types of resources.",
    },
  ];

  return (
    <Joyride
      steps={steps}
      run={runTour}
      continuous={true}
      scrollToFirstStep={true}
      onEvent={handleJoyrideEvent}
      options={{
        skipBeacon: true,
        showProgress: true,
        buttons: ["back", "skip", "primary"],
      }}
      styles={{
        buttonPrimary: {
          backgroundColor: "var(--color-primary)",
          color: "var(--color-primary-text)",
          fontFamily: "var(--font-family-base)",
          borderRadius: "var(--radius-sm)",
        },
        buttonBack: {
          backgroundColor: "var(--color-unfocus-border)",
          color: "var(--color-text-muted)",
          borderRadius: "var(--radius-sm)",
          marginRight: "var(--space-3)",
        },
        buttonSkip: {
          color: "var(--color-monochrome-muted)",
        },
        tooltipContent: {
          marginBottom: "var(--space-4)",
        },
        spotlight: {
          stroke: "var(--color-focus-border)",
          strokeWidth: 2,
        },
      }}
    />
  );
};

export default JoyRide;
